import { Formik, FormikHelpers, FormikValues } from 'formik';
import React, { createContext } from 'react';
import { AnySchema } from 'yup';

interface Props {
  children: React.ReactElement | React.ReactElement[];
  className?: string;
  inicial?: object;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSubmit: (valores: any, form: FormikHelpers<FormikValues>) => void;
  regras?: AnySchema;
  desabilitado?: boolean;
  emLinha?: boolean;
}

interface Contexto {
  emLinha: boolean;
  regras?: AnySchema;
}

export const FormContexto = createContext<Contexto>({
  emLinha: false,
});

const Form = (props: Props): React.ReactElement => {
  const {
    children,
    className,
    inicial,
    onSubmit,
    regras,
    desabilitado = false,
    emLinha = false,
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const campos: any = {};

  if (regras) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Object.keys(regras.fields).forEach((chave) => {
      campos[chave] = '';
    });
  }

  return (
    <FormContexto.Provider value={{ emLinha, regras }}>
      <Formik
        initialValues={
          inicial && Object.keys(inicial).length ? inicial : campos
        }
        validationSchema={regras}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(formikProps) => {
          const erros: string[] = [];
          const { status } = formikProps;

          if (status) {
            Object.keys(status.errors).forEach((campo) => {
              Object.keys(status.errors[campo]).forEach((erro) => {
                erros.push(`${campo}: ${status.errors[campo][erro]}`);
              });
            });
          }

          return (
            <form
              className={className}
              onSubmit={formikProps.handleSubmit}
              encType="multipart/formdata"
            >
              {erros.length ? (
                <React.Fragment>
                  <p className="fw-bold text-danger">
                    Erros retornados pelo servidor
                  </p>
                  <ul>
                    {erros.map((erro) => (
                      <li key={erro} className="text-danger">
                        {erro}
                      </li>
                    ))}
                  </ul>
                </React.Fragment>
              ) : null}
              <fieldset
                disabled={
                  formikProps.isSubmitting || desabilitado ? true : false
                }
              >
                {children}
              </fieldset>
            </form>
          );
        }}
      </Formik>
    </FormContexto.Provider>
  );
};

export default Form;
